if (dataLayerData.page.template != 'cart') {
  $(document).ready(function () {
    // Can use this by default or the onclick attribute directly
    var checkout_button_selectors = '[name="checkout"], [href="/checkout"], form[action="/checkout"] input[type="submit"], .checkout_button';
    $(document).on('click', checkout_button_selectors, function (e) {
      if (!$(this).data('disable-recharge')) {
        e.preventDefault();
        reChargeSaveCartNoteAndRedirect();
      }
    });
    reChargeShowButton($)
  });
}
